import React from 'react';
import { Check, Minus } from 'lucide-react';

export function Checkbox({ checked, indeterminate, onChange, className = '', label }) {
  return (
    <label className={`inline-flex items-center gap-2 cursor-pointer ${className}`}>
      <div
        onClick={onChange}
        className={`
          w-4 h-4 rounded border-2 flex items-center justify-center transition-colors cursor-pointer
          ${checked || indeterminate
            ? 'bg-sky-600 border-sky-600'
            : 'bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-600 hover:border-sky-500'}
        `}
      >
        {indeterminate
          ? <Minus className="w-2.5 h-2.5 text-white" />
          : checked
            ? <Check className="w-2.5 h-2.5 text-white" />
            : null}
      </div>
      {label && <span className="text-sm text-slate-700 dark:text-slate-300">{label}</span>}
    </label>
  );
}
